import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { CopyrightComponent } from '#/app/shared/ui/copyright/copyright';
import { LogoComponent } from '#/app/shared/ui/logos/logo/logo';

@Component({
  selector: 'app-authentication-layout',
  imports: [CopyrightComponent, LogoComponent, RouterLink],
  templateUrl: './authentication-layout.html',
  styleUrls: ['./authentication-layout.scss'],
})
export class AuthenticationLayoutComponent {}
